(function () {
    'use strict';

    angular.module('elogbooks.admin.spillage-types', []);
})();
